import React, { Component } from 'react';
import PurchaseMain from '../../../components/User/Purchase/purchase.main';
import LayoutPreload from '../../../components/Preload/layout.preload';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateWording, UserGetPurchaseOrderByUserId, UserGetPurchaseOrderByInvoice, LanguageChange } from '../../../store/actions';
import _ from 'lodash';

class UserPurchase extends Component {
    componentDidMount() {
        const { updateWording } = this.props;
        updateWording();
        this.handlerSet();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            !_.isEqual(prevProps.isAuthenticated, this.props.isAuthenticated) ||
            !_.isEqual(prevProps.currentLanguage, this.props.currentLanguage)
        ) {
            this.handlerSet();
        }
    }

    handlerSet = () => {
        const { UserGetPurchaseOrderByUserId, isAuthenticated, match, UserGetPurchaseOrderByInvoice } = this.props;
        let invoice = match.params.hasOwnProperty("invoice");
        if (isAuthenticated || localStorage.getItem('Hello') !== null) {
            if (invoice) UserGetPurchaseOrderByInvoice(match.params.invoice);
            else UserGetPurchaseOrderByUserId();
        }
    }

    render() {
        const { orderFetching } = this.props;

        if (orderFetching) {
            return <LayoutPreload />;
        }

        return <PurchaseMain />;
    }
}

const mapStateToProps = ({ user, login, language }) => ({
    orderFetching: user.purchase.isFetching,
    isAuthenticated: login.isAuthenticated,
    currentLanguage: language.currentLanguage
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            updateWording: updateWording,
            UserGetPurchaseOrderByUserId: UserGetPurchaseOrderByUserId,
            UserGetPurchaseOrderByInvoice: UserGetPurchaseOrderByInvoice
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserPurchase);
